import script from "./searchbox.vue?vue&type=script&setup=true&lang=js"
export * from "./searchbox.vue?vue&type=script&setup=true&lang=js"

import "./searchbox.vue?vue&type=style&index=0&id=10797306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10797306"]])

export default __exports__